import { useEffect, useState } from 'react';
import { apiErrorHandling } from 'src/api/apierrorhandling';
import { getSpvTaxInformation } from 'src/api/stoApi';
import { ITaxReport } from 'src/models';
import { generalStore } from 'src/stores/GeneralStore';

export const useSpvTaxInformation = (spvId: string | undefined) => {
  const [taxReports, setTaxReports] = useState<ITaxReport[] | null>(null);
  useEffect(() => {
    const load = async () => {
      generalStore.setIsLoading(true);
      try {
        if (!spvId) {
          return;
        }
        const response = await getSpvTaxInformation(spvId);
        setTaxReports(response.data.data);
      } catch (error: any) {
        apiErrorHandling(error);
      } finally {
        generalStore.setIsLoading(false);
      }
    };
    load();
  }, [spvId]);

  return taxReports;
};
